export class Icon {

    constructor(
        public identifier_1 : string, // Fontawesome reference 'arrows-left-right'
        public identifier_2? : string, // Cloudinary folder and file 'icons/uruguay-geo-marker'
        public id? : number,
        public name? : string,
        public category? : string,
        public type? : string,
    ) {}

}